import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";
import * as React from "react";

export function MilkrunColumnMenu(props: GridColumnMenuProps) {
  const data = [{ Milkrun: "Yes" }, { Milkrun: "No" }];

  return (
    <GridColumnMenuCheckboxFilter
      expanded
      filterable
      {...props}
      data={data}
      searchBox={() => null}
    />
  );
}
